import React from "react";

function LeaguePropsSkeleton({ rows = 6 }: { rows?: number }) {
    return (
        <div className="props-league-skeleton" aria-hidden="true" aria-busy="true">
            {Array.from({ length: rows }).map((_, i) => (
                <div key={i} className="props-league-content props-league-skeleton-row">
                    <span className="props-league-skeleton-line props-league-skeleton-line--title" />
                    <span className="props-league-skeleton-line props-league-skeleton-line--sub" />
                    <span className="props-league-skeleton-arrow" />
                </div>
            ))}
        </div>
    );
}

export function LeaguePropsTabsSkeleton({ tabs = 5 }: { tabs?: number }) {
    return (
        <div className="props-tabs props-league-tabs" aria-hidden="true">
            {Array.from({ length: tabs }).map((_, i) => (
                <div key={i} className="tab-props props-league-tab">
                    <span className="props-league-skeleton-tab" />
                </div>
            ))}
        </div>
    );
}

export default LeaguePropsSkeleton;
